const subscribers = new Set()
const pending = new Set()

function subscribe(fn) {
  subscribers.add(fn)
  if (pending.size) {
    pending.forEach((k) => fn({ popupKey: k }))
    pending.clear()
  }
  return () => subscribers.delete(fn)
}

function request({ popupKey }) {
  if (!subscribers.size) {
    pending.add(popupKey)
    return
  }
  subscribers.forEach((fn) => fn({ popupKey }))
}

export default { subscribe, request }
